var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{class:'expand-icon ' + (_vm.expanded ? 'expanded' : '')},[_vm._v("expand_more")])
}
var staticRenderFns = []

export { render, staticRenderFns }